---
de:
  liquidity:
    actual: Aktuell
    base: Basis
    data_sources:
      owner: Eigentümer
      simulation: Simulation
    expected: Erwartet
    file_processed: Datei verarbeitet
    file_too_large: Die Datei ist zu groß
    invalid_file: Die Datei konnte nicht gelesen werden. Sie ist möglicherweise beschädigt oder im falschen Format.
    liquidity: Liquiditätsplanung
    mean_historical: Mittelwert historische Daten
    no_data_for_chart: Für die ausgewählten Filter liegen keine Daten für dieses Diagramm vor
    production: Produktion
    pxx_production: P%{number} Produktion
    pxx_spot_price: P%{number} Spotpreis
    revenue: Umsatz
    sim_high: Simuliert hoch
    sim_low: Simuliert tief
    simulated_production: Simulierte Produktion
    simulated_revenue_development: Umsatzentwicklung
    spot_price: Spotpreis
    variation: Variation
